<template>
  <v-container fluid py-0>
    <v-row>
      <v-col class="py-0">
        <v-container fluid pt-0>
          <v-row justify="end" align="center">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    dark
                    color="primary"
                    @click="showSendNotificationDialog = true"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Notification</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-card outlined>
      <v-data-table
        :items="items"
        :headers="headers"
        :loading="$apollo.loading"
      >
        <template v-slot:item.createdAt="{ item }">
          {{ item.createdAt | formatDate }}
        </template>
      </v-data-table>
    </v-card>
    <send-notification-dialog
      :show="showSendNotificationDialog"
      @send="onPushNotification"
      @close="showSendNotificationDialog = false"
    />
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import SendNotificationDialog from "./SendNotificationDialog.vue";

const LIST_QUERY = gql`
  query itiNotifications($filter: ItineraryNotificationFilterType) {
    itineraryNotifications(first: 1000, filter: $filter) {
      edges {
        node {
          id
          createdAt
          title
          body
          status
          notificationToken {
            id
            token
            device
          }
        }
      }
    }
  }
`;

const SEND_NOTIFICATION_MUTATION = gql`
  mutation sendItiNotification($input: ItineraryNotificationInput!) {
    sendItineraryNotification(input: $input) {
      success
      message
      error
    }
  }
`;
export default {
  components: { SendNotificationDialog },
  name: "itinerary-push-notifications",
  props: {
    itineraryId: {
      type: String,
      required: true,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      showSendNotificationDialog: false,
      headers: [
        { text: "Date", value: "createdAt" },
        { text: "Title", value: "title" },
        { text: "Message", value: "body" },
        { text: "Status", value: "status" },
      ],
    };
  },

  computed: {
    items() {
      return this.itineraryNotifications && this.itineraryNotifications.edges
        ? this.itineraryNotifications.edges.map(removeGQLTypename)
        : [];
    },
  },
  methods: {
    onPushNotification(payload) {
      this.$apollo
        .mutate({
          mutation: SEND_NOTIFICATION_MUTATION,
          variables: { input: { ...payload, itineraryId: this.itineraryId } },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: { filter: { itineraryId_eq: this.itineraryId } },
            },
          ],
        })
        .then((res) => {
          if (res.data.sendItineraryNotification.success) {
            this.$store.dispatch("showAppSnackbar", {
              msg: res.data.sendItineraryNotification.message,
            });
          } else {
            this.$store.dispatch("showAppSnackbar", {
              msg: res.data.sendItineraryNotification.error,
              color: "error",
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err.graphQLErrors.map((e) => e.message).join(", "),
            color: "error",
          });
        });
      this.showSendNotificationDialog = false;
    },
  },
  apollo: {
    itineraryNotifications: {
      query: LIST_QUERY,
      variables() {
        return { filter: { itineraryId_eq: this.itineraryId } };
      },
      skip() {
        return this.itineraryId == "";
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/itineraries/notifications/ItineraryPushNotifications.vue